<template>
  <b-card :title="$t('info')" class="mb-4 project-state-card">
    <div v-if="shouldShowManagementSystemWarning" class="">
      <div class="warning-toast">
        {{ $t('solar_plant_gt_7kwp_warning') }}
      </div>
    </div>
  </b-card>
</template>

<script>
import { management_system_required } from '@/helpers/solarPlant';

export default {
  props: {
    project: { type: Object },
  },
  computed: {
    shouldShowManagementSystemWarning() {
      return management_system_required(this.project.solarPlant);
    },
  },
};
</script>

<style scoped lang="scss">
.project-state-card {
  // max-width: 30rem;
}
</style>
